module.exports = __webpack_public_path__ + "img/icon_chenggong@2x.12becfb9.png";